var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTag(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.25 1.5L0.75 15L9 23.25L22.5 9.75V1.5H14.25ZM18 7.5C17.7033 7.5 17.4133 7.41203 17.1666 7.2472C16.92 7.08238 16.7277 6.84811 16.6142 6.57403C16.5006 6.29994 16.4709 5.99834 16.5288 5.70736C16.5867 5.41639 16.7296 5.14912 16.9393 4.93934C17.1491 4.72956 17.4164 4.5867 17.7074 4.52882C17.9983 4.47094 18.2999 4.50065 18.574 4.61418C18.8481 4.72771 19.0824 4.91997 19.2472 5.16664C19.412 5.41332 19.5 5.70333 19.5 6C19.5 6.39782 19.342 6.77936 19.0607 7.06066C18.7794 7.34196 18.3978 7.5 18 7.5Z",
    fill: "#130D0D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTag);
export default __webpack_public_path__ + "static/media/tag.5cf81c1eae99e481db2766ed0e99c2b5.svg";
export { ForwardRef as ReactComponent };